const ProgressBar = ({ title, description, percentage }) => {
  return (
    <div className="px-6 py-3 space-y-2">
      <div className="flex justify-between items-center">
        <span className="text-sm font-bold text-secondary-800">{title}</span>
        <span className="text-sm font-semibold text-secondary-500">{description}</span>
      </div>

      <div className="w-full bg-slate-105 bg-gray-100 rounded-full h-1.5 overflow-hidden">
        <div
          className="bg-blue-600 h-full rounded-full transition-all duration-500"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  )
}

export default ProgressBar;
